export { default } from './Feed';
export { default as ArticlesSingle } from './Single';



// WEBPACK FOOTER //
// ./src/articles/index.js